import { render, staticRenderFns } from "./addReply.vue?vue&type=template&id=2eff195c&scoped=true&"
import script from "./addReply.vue?vue&type=script&lang=js&"
export * from "./addReply.vue?vue&type=script&lang=js&"
import style0 from "./addReply.vue?vue&type=style&index=0&id=2eff195c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eff195c",
  null
  
)

export default component.exports